// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2UbQC","savePackageButton":"ClientWallet_savePackageButton__2Q-PV"};